
const HoliData2026 = [
    {
        id: 1,
        imageSource: require("../../../Assets/Events/2026/Holi-2026/Holi_26_1.webp")
    },
    {
        id: 2,
        imageSource: require("../../../Assets/Events/2026/Holi-2026/Holi_26_2.webp")
    },
    {
        id: 3,
        imageSource: require("../../../Assets/Events/2026/Holi-2026/Holi_26_3.webp")
    },
    {
        id: 4,
        imageSource: require("../../../Assets/Events/2026/Holi-2026/Holi_26_4.webp")
    },
    {
        id: 5,
        imageSource: require("../../../Assets/Events/2026/Holi-2026/Holi_26_5.webp")
    },
    {
        id: 6,
        imageSource: require("../../../Assets/Events/2026/Holi-2026/Holi_26_6.webp")
    },
];

export default HoliData2026;